import { ref } from '@vue/composition-api'
import api from '../../services/api'

export default function (filtro) {
  const valores = ref([
    {
      titulo: 'Quantidade de mensagens',
      avatar: 'MessageSquareIcon',
      avatarVariant: 'light-primary',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
    },
    {
      titulo: 'Lidas',
      avatar: 'BookOpenIcon',
      avatarVariant: 'light-success',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
      query: 'Lidas',
    },
    {
      titulo: 'Não lidas',
      avatar: 'BookIcon',
      avatarVariant: 'light-warning',
      subTitulo: 'total',
      valor: 0,
      negativo: true,
      query: 'NaoLidas',
    },
    {
      titulo: 'Importantes não lidas',
      avatar: 'AlertCircleIcon',
      avatarVariant: 'light-danger',
      subTitulo: 'total',
      valor: 0,
      negativo: true,
      query: 'RelevanteNaoLido',
    },
    {
      titulo: 'Quantidade de e-Processos',
      avatar: 'MessageSquareIcon',
      avatarVariant: 'light-primary',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
      negativo: true,
    },
    {
      titulo: 'e-Processos não lidas',
      avatar: 'BookIcon',
      avatarVariant: 'light-warning',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
      negativo: true,
    },
    {
      titulo: 'Termos de exclusão',
      avatar: 'AlertCircleIcon',
      avatarVariant: 'light-danger',
      subTitulo: 'total',
      valor: 0,
      negativo: true,
    },
    {
      titulo: 'Quantidade de Termo(s) de Intimação',
      avatar: 'MessageSquareIcon',
      avatarVariant: 'light-primary',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
      negativo: true,
    },
    {
      titulo: 'Termo(s) de Intimação não lidas',
      avatar: 'BookIcon',
      avatarVariant: 'light-warning',
      subTitulo: 'nos últimos 60 dias',
      valor: 0,
      negativo: true,
    },
  ])

  const data60DiasAntes = new Date()
  data60DiasAntes.setDate(data60DiasAntes.getDate() - 60)

  api.getContadoresCaixaPostal(filtro)
    .then(payload => {
      valores.value = [
        {
          titulo: 'Quantidade de mensagens',
          avatar: 'MessageSquareIcon',
          avatarVariant: 'light-primary',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalMsg,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
        },
        {
          titulo: 'Lidas',
          avatar: 'BookOpenIcon',
          avatarVariant: 'light-success',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalLidas,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
          query: 'Lidas',
        },
        {
          titulo: 'Não lidas',
          avatar: 'BookIcon',
          avatarVariant: 'light-warning',
          subTitulo: 'total',
          valor: payload.data.totalNaoLidas,
          negativo: true,
          query: 'NaoLidas',
        },
        {
          titulo: 'Importantes não lidas',
          avatar: 'AlertCircleIcon',
          avatarVariant: 'light-danger',
          subTitulo: 'total',
          valor: payload.data.importantesNaoLidas,
          negativo: true,
          query: 'RelevanteNaoLido',
        },
        {
          titulo: 'Quantidade de e-Processos',
          avatar: 'MessageSquareIcon',
          avatarVariant: 'light-primary',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalEprocesso,
          negativo: true,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
          query: 'EProcesso',
        },
        {
          titulo: 'e-Processos não lidas',
          avatar: 'BookIcon',
          avatarVariant: 'light-warning',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalEprocessoNaoLidas,
          negativo: true,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
          query: 'EProcessoNaoLida',
        },
        {
          titulo: 'Termos de exclusão',
          avatar: 'AlertCircleIcon',
          avatarVariant: 'light-danger',
          subTitulo: 'total',
          valor: payload.data.totalTermoExclusao,
          negativo: true,
          query: 'TermoExclusao',
        },
        {
          titulo: 'Quantidade de Termo(s) de Intimação',
          avatar: 'MessageSquareIcon',
          avatarVariant: 'light-primary',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalTermoIntimacao,
          negativo: true,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
          query: 'TermoIntimacao',
        },
        {
          titulo: 'Termo(s) de Intimação não lidas',
          avatar: 'BookIcon',
          avatarVariant: 'light-warning',
          subTitulo: 'nos últimos 60 dias',
          valor: payload.data.totalIntimacaoNaoLidas,
          negativo: true,
          dataInicio: data60DiasAntes.toLocaleDateString('pt-BR'),
          query: 'TermoIntimacaoNaoLida',
        },
      ]
    })

  return {
    totaisCaixaPostal: valores,
  }
}
